<script setup lang="ts">
import { AppText } from '@shared/ui/typography'

/** The audio-response affordance, stated. `audio_response` carries no fields, so no props and no
 *  attribute inheritance. The button is disabled and wired to nothing: the preview records no
 *  audio and requests no microphone. */
defineOptions({
  name: 'PreviewAudioResponse',
  inheritAttrs: false,
})
</script>

<template>
  <div class="preview-audio-response">
    <button
      class="preview-audio-response__record"
      type="button"
      disabled
    >
      Record answer
    </button>
    <AppText
      name="body2"
      color="slate-500"
    >
      The kid records a spoken response.
    </AppText>
  </div>
</template>

<style scoped lang="scss" src="./PreviewAudioResponse.scss" />
